import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RepairerSitesStore } from '../repairer-sites/repairer-sites-store.component';
import { AbstractDynamicDialogComponent } from '../../../components/dynamic-dialog/abstract-dynamic-dialog.component';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { BrowserAutoFillDisabledDirective } from '../../../directives/browser-auto-fill-disabled.directive';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-set-dashboard-day',
  templateUrl: './set-dashboard-day.component.html',
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, BrowserAutoFillDisabledDirective, MatError, MatIcon]
})
export class SetDashboardDayComponent extends AbstractDynamicDialogComponent implements OnInit {
  #dialogRef = inject(MatDialogRef<SetDashboardDayComponent>);
  #fb = inject(UntypedFormBuilder);
  #repairerSitesStore = inject(RepairerSitesStore);

  dashboardDaysForm: UntypedFormGroup = this.#fb.group({
    days: [null, Validators.min(1)]
  });

  get days() {
    return this.dashboardDaysForm.controls.days;
  }

  ngOnInit() {
    this.dynamicDialogService.dialogRefSignal.set(this.#dialogRef);

    const { dashboardDays = 30 } = this.#repairerSitesStore.selectedRepairerSite() ?? {};
    this.days.patchValue(dashboardDays);
  }

  saveOrExecuteAction() {
    this.#repairerSitesStore.updateDashboardDays(this.days.value);
  }
}
